import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'count-badge',
  standalone: false,
  templateUrl: './count-badge.component.html',
  styleUrl: './count-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CountBadgeComponent {
   public count ?= input<number>(0);
}
